import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import { mediaQuery, empty_key_message } from '../util/util';
//import empty_key_message from '../util/util';

import './ComponentsTable.css';

const alignCenter = {
  thStyle: {textAlign: 'center'},
  tdStyle: {textAlign: 'center'},
};

const setIndentClass = (cell, row) => row.indent ? 'indent' : '';
const rowClassNameFormat = (row) => {
  let className = row.subheader ? 'subheader' : '';
  className += row.level ? `-${row.level}` : '';
  return className;
};

class ComponentsTable extends Component {
  componentDidMount() {
    const csvData = this.props.tableData.map(row => {
      return (row.category && row.level)
        ? {category: '  ' + row.category}
        : row.category
          ? {category: row.category}
          : row;
    });
    this.props.setCsvData(csvData);
  }

  getClaimableMessage(){
      if(this.props.tableType === "claimable"){
          return <div className = "extraSmall">
        The potential nutrient claims provided here are based
          on conditions specified by FSANZ as at 1 June 2018.
          We make no assurances of legal compliance and should you intend
          making any claim on labels, promotional material or elsewhere
          it is your sole responsibility to ensure you meet current
          regulatory requirements.</div>;
      }else{
          return "";
      }

  }

  render() {
    return (
      <div className={'ComponentsTable' + (this.props.tableType ? ` ${this.props.tableType}` : '')}>


            <div className = "extraSmall">
            If data is to be used for food labelling it is your responsibility
            to ensure you comply with FSANZ labelling requirements.</div>

            {this.getClaimableMessage()}
            <br/>
            <small>* Percentage daily intakes are based on
                an average adult diet of 8700 kJ as specified by FSANZ.</small>
        <div><small> {empty_key_message}</small></div>


        <BootstrapTable
          data={this.props.tableData}
          hover
          condensed
          bordered={false}
          trClassName={rowClassNameFormat}>

          {(this.props.tableType === 'fullGrouped' || this.props.tableType === 'basic')&&
            <TableHeaderColumn
              dataField='category'
            >
              CATEGORY
            </TableHeaderColumn>
          }

          <TableHeaderColumn
            isKey
            dataField='nutrient'
            columnClassName={setIndentClass}
          >
            NUTRIENT
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField='unit'
            {...alignCenter}
          >
            UNIT
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField='qps'
            {...alignCenter}
          >
            {mediaQuery('QTY PER SERVE', 'QUANTITY PER SERVE')}
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField='rdi'
            dataFormat={cell => cell ? `${cell} %` : ''}
            {...alignCenter}
          >
            %DI* PER SERVE
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField='qpg'
            {...alignCenter}
          >
            {mediaQuery('QTY PER 100 g', 'QUANTITY PER 100 g')}
          </TableHeaderColumn>

          {this.props.tableType === 'claimable' &&
            <TableHeaderColumn
              dataField='claim'
            >
              POTENTIAL CLAIM
            </TableHeaderColumn>
          }
        </BootstrapTable>

      </div>
    );
  }
}

ComponentsTable.propTypes = {
  tableType: PropTypes.string,
  tableData: PropTypes.array.isRequired,
  setCsvData: PropTypes.func.isRequired,
};

export default ComponentsTable;



// WEBPACK FOOTER //
// ./src/components/foodDetail/ComponentsTable.js